document.addEventListener('DOMContentLoaded', function() {
    var img = document.createElement('img');
    img.src = 'https://neuemaison.co/cdn/shop/files/IMG_3220.webp?v=1709923981';
    img.style.width = '100%';
    img.style.height = 'auto';
    img.id = 'tab_image';
    
    var button = document.querySelector('.sub-tab-link');
    if(button) {
        button.appendChild(img);
    }
});
